export default {"src":"/_next/static/media/omg.cc3b3919.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};